<template lang='pug' src='./footer.pug'></template>

<script>
import Icon from '../icon/icon'

export default {
  props: ['content'],
  components: {
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// footer.vue?0e446ca8